<template>
    <div class="mt-10">
        <ul v-if="reviews">
            <li v-for="review in reviews.data" :key="review.id" class="mt-10">
                <div class="flex items-center gap-4">
                    <img :src="review.photourl" class="w-14 h-14 rounded-full" />

                    <div>
                        <button type="button" class="text-xl font-poppins text-primary" @click="$emit( 'viewPatient', review.patient_id )">
                            {{ review.username }}
                        </button>

                        <p class="text-base font-light text-gray-500">
                            {{ review.date }}
                        </p>

                        <p class="text-base font-light text-gray-500 flex items-center">
                            <star-rating :rating="review.stars" :read-only="true" :increment="0.01" :star-size="20" class="mr-2" />
                            estrelas
                        </p>
                    </div>
                </div>

                <p class="font-normal text-base text-gray-500 mt-4">
                    {{ review.description }}
                </p>
            </li>
        </ul>
    </div>
</template>

<script>

import starRating from 'vue-star-rating'
import axios from 'axios'

export default {
    props: {
        professionalId: {
            type: String,
            required: true,
        }
    },

    emits: [ 'viewPatient' ],

    components: {
        starRating,
    },

    data() {
        return {
            reviews: null,
        }
    },

    mounted: function () {
        this.getReviewsOfProfessional( this.$props.professionalId )
    },


    methods: {
        getReviewsOfProfessional: async function ( id ) {
            try {
                const response = await axios.get( '/professionals-dashboard/reviews', { params: { id } } )

                this.reviews = response.data
            }

            catch ( err ) {
                this.$toast.error( 'Erro ao buscar lista de avaliações' )
            }
        }
    }

}


</script>
